import Cookies from 'js-cookie'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    options: [{
      value: 'trap',
      label: 'Trap'
    }, {
      value: 'R&B',
      label: 'R&B'
    }, {
      value: 'jazz',
      label: 'Jazz'
    }, {
      value: 'dirtySouth',
      label: 'Dirty South'
    }, {
      value: 'oldSchool',
      label: 'Old School'
    },{
      value: 'westCoast',
      label: 'West Coast'
    }, {
      value: 'eastCoast',
      label: 'East Coast'
    }, {
      value: 'funk',
      label: 'Funk'
    }],
    notificationData: {},
    addLrc: '',//歌词
  },
  mutations: {
    ADD_LRC:(state, addLrc) => {
      state.addLrc = addLrc
    },
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    EDIT_INFORM: (state, notificationData) => {
      state.notificationData = notificationData
    }
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    editInform({ commit }, notificationData) {
      commit('EDIT_INFORM', notificationData)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js